import mt4ClosedTradesReport from './mt4ClosedTradesReport';
import mt4DepositWithdrawlReport from './mt4DepositWithdrawlReport';
import mt4CreditReport from './mt4CreditReport';
import mt4AccountReport from './mt4AccountReport';
import mt4SummaryReport from './mt4SummaryReport';
import mt4SeregatedReport from './mt4SeregatedReport';
import mt4EquityReport from './mt4EquityReport';
import mt4ProfitLossReport from './mt4ProfitLossReport';
import mt4EquityMultiReport from './mt4EquityMultiReport';
import analyze from './analyze';
import symbolProfit from './symbolProfit';
import downloadReport from './downloadReport';
import floatingPL from './floatingPLReport';
import openTrades from './openTradesReport';
import profitTopList from './profitTopList';
import closedTradesReport from './closedTradesReport';

const managerLanguages = [
    mt4ClosedTradesReport,
    mt4DepositWithdrawlReport,
    mt4CreditReport,
    mt4AccountReport,
    mt4SummaryReport,
    mt4SeregatedReport,
    mt4EquityReport,
    mt4ProfitLossReport,
    mt4EquityMultiReport,
    analyze,
    symbolProfit,
    downloadReport,
    floatingPL,
    openTrades,
    profitTopList,
    closedTradesReport,
]

export default managerLanguages;


// WEBPACK FOOTER //
// ./src/language/manager-report/index.js